import React from 'react';
import CreateReactClass from 'create-react-class';
import { Immutable } from 'nuclear-js';

import Reactor from 'data/reactor';
import Loader from 'data/loader';
import RuntimeGetters from 'data/app-runtime/getters';
import PropTypes from 'prop-types';

import StudentList from '../student-list/index';
import TermDropdown from './term-dropdown';
import AdjacentStudentButton from './adjacent-student-button';
import { findShowMethodForModal } from 'utils/runtime';
import Analytics from 'utils/analytics';
import CommonValues from 'resources/common-values';
import PrintAndShare from './print-and-share/index';

export default CreateReactClass({
    displayName: 'options-heading',
    mixins: [Reactor.ReactMixin],

    propTypes: {
        currentStudentBid: PropTypes.string,
        isSingleStudentMode: PropTypes.bool,
        linkingStudies: PropTypes.instanceOf(Immutable.List).isRequired,
        terms: PropTypes.instanceOf(Immutable.List),
        termsWithTestEvents: PropTypes.instanceOf(Immutable.List),
        selectedTermNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        selectedSubject: PropTypes.instanceOf(Immutable.Map),
        selectedModule: PropTypes.string,
        studentInfo: PropTypes.instanceOf(Immutable.List),
        selectedClass: PropTypes.instanceOf(Immutable.Map), // Typically required, but not in isSingleStudentMode
        students: PropTypes.instanceOf(Immutable.List).isRequired,
        unsavedData: PropTypes.bool,
        modalReferences: PropTypes.object,
        reportsQueueLink: PropTypes.string.isRequired,
    },

    getDataBindings() {
        /* allowAdvanceStudent is only observed here */
        return {
            allowAdvanceStudent: RuntimeGetters.allowAdvanceStudent,
        };
    },

    onRefreshStudent() {
        const refreshAction = () => Loader.reloadStudent(this.props.currentStudentBid);
        Analytics.recordButtonClick(CommonValues.SectionIDs.studentInfo, 'reload-student');
        if (this.props.unsavedData) {
            const showSaveDataPrompt = findShowMethodForModal(
                this.props.modalReferences,
                CommonValues.sharedModalReferences.saveDataPrompt
            );
            showSaveDataPrompt()
                .then(() => {
                    refreshAction();
                })
                .catch(() => {
                    /* do nothing */
                });
        } else {
            refreshAction();
        }
    },

    printPage() {
        const selectedSubject = Reactor.evaluate(RuntimeGetters.selectedSubject);
        Analytics.recordButtonClick(CommonValues.SectionIDs.studentInfo, 'print', selectedSubject.get('name', ''));
        window.print();
    },

    /* These navigation buttons do not render during a single-student search results */
    renderStudentNavigationButtons() {
        if (this.props.isSingleStudentMode || this.props.students.size === 1) {
            return null;
        }
        const buttons = [];
        buttons.push(
            <AdjacentStudentButton
                key="previous-student-button"
                currentStudentBid={this.props.currentStudentBid}
                advancementDirection="previous"
                allowAdvanceStudent={this.state.allowAdvanceStudent}
                unsavedData={this.props.unsavedData}
                modalReferences={this.props.modalReferences}
            />
        );
        buttons.push(
            <AdjacentStudentButton
                key="next-student-button"
                currentStudentBid={this.props.currentStudentBid}
                advancementDirection="next"
                allowAdvanceStudent={this.state.allowAdvanceStudent}
                unsavedData={this.props.unsavedData}
                modalReferences={this.props.modalReferences}
            />
        );
        return buttons;
    },

    /* This studentList Popover does not render during a single-student search results */
    renderStudentListPopover() {
        return this.props.isSingleStudentMode ? null : (
            <StudentList
                key="student-list"
                students={this.props.students}
                selectedClass={this.props.selectedClass}
                modalReferences={this.props.modalReferences}
            />
        );
    },

    render() {
        return (
            <div id="student-options-heading">
                <TermDropdown
                    key="term-dropdown"
                    studentBid={this.props.currentStudentBid}
                    termsWithTestEvents={this.props.termsWithTestEvents}
                    selectedTermNumber={this.props.selectedTermNumber}
                    unsavedData={this.props.unsavedData}
                />
                <i
                    key="refresh-student"
                    className="icon icon-repeat refresh-student"
                    onClick={this.onRefreshStudent}
                    title="Problems loading the page? Click to reload."
                    tabIndex="0"
                />

                {this.renderStudentNavigationButtons()}
                {this.renderStudentListPopover()}

                <PrintAndShare
                    isSingleStudentMode={this.props.isSingleStudentMode}
                    linkingStudies={this.props.linkingStudies}
                    termsWithTestEvents={this.props.termsWithTestEvents}
                    selectedTermNumber={this.props.selectedTermNumber}
                    selectedSubject={this.props.selectedSubject}
                    selectedModule={this.props.selectedModule}
                    studentInfo={this.props.studentInfo}
                    selectedClass={this.props.selectedClass}
                    students={this.props.students}
                    reportsQueueLink={this.props.reportsQueueLink}
                />
            </div>
        );
    },
});
